export class ProfessionalOrderAcceptanceModel {

  constructor(
    public orderId: string,
    public isAccepted: boolean,
    public message: string,
    public reason: string
  ) {  }
}
